import { Category } from './../../generics/data-printer/data-printer.component';
import { ErrorResponse } from './../../../models/error.model';
import { ActivatedRoute } from '@angular/router';
import { QuotesService } from './../../../services/quotes.service';
import { UtilsService } from './../../../services/utils.service';
import { QuotationService, Quote } from './../../../models/quote.model';
import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-quote-details',
    templateUrl: './quote-details.component.html',
    styleUrls: ['./quote-details.component.scss']
})
export class QuoteDetailsComponent implements OnInit {

    quote?: Quote;
    servicesCategories: Category[] = [];

    constructor(
        public utilsService: UtilsService,
        private quoteService: QuotesService,
        private route: ActivatedRoute
    ) { }

    ngOnInit(): void {
        this.route.params.subscribe(params => {
            if (params.id) {
                this.quoteService.getQuoteById(params.id).subscribe(
                    quote => {
                        this.quote = quote;
                        this.servicesCategories.push(this.mapServicesToCategory(quote.servicios));
                    },
                    (error: ErrorResponse) => this.utilsService.alert('Error al obtener cotización', error.error?.descripcion)
                );

            }
        });
    }

    mapServicesToCategory(services: QuotationService[]) {
        const servicesCategory: Category = { name: 'Servicios ', items: [] };
        services.forEach(service => {
            servicesCategory.items.push({ value: service.nombre, alignment: 'center' });
        });

        return servicesCategory;
    }

}
